// @flow

import get from 'lodash/get';
import type { RequestSearchAdsCarsApi } from '../../../types/cars/RequestSearchAdsCarsApi';
import guardNegativeOrZeroNumber from '../../utils/guardNegativeOrZeroNumber';

type RequestData = {
  searchParams: Map<string, any>,
  trovit: Object,
  userId: ?string,
};

export default function map(requestData: RequestData): RequestSearchAdsCarsApi {
  const { searchParams, trovit, userId } = requestData;
  const origin = trovit.origin;

  return {
    pathParams: {
      countryCode: String(get(searchParams, 'country_code')),
      verticalName: String(get(searchParams, 'vertical_name')),
    },
    queryParams: {
      retrieveKeyword: Boolean(get(searchParams, 'retrieveKeywords')),
      boostAdsSince: get(searchParams, 'boost_ads_since'),
      what: String(get(searchParams, 'what_d')),
      dealTypeId: Number(get(searchParams, 'type_id')),
      'page[size]': Number(get(searchParams, ['sections', 'organic'])),
      'page[organic][size]': Number(get(searchParams, ['sections', 'organic'])),
      'page[premium][size]': Number(get(searchParams, ['sections', 'premium'])),
      countryCode: String(get(searchParams, 'country_code')),
      device: 'mobile',
      clientId: 'pwa-mobile',
      originId: get(searchParams, 'origin'),
      'page[number]': get(searchParams, 'page') || 1,
      'abTest[id]': get(trovit, ['abTest', 'id']),
      'abTest[option]': get(trovit, ['abTest', 'option']),
      'abTest[platform]': get(trovit, ['abTest', 'platform']),
      sort: get(searchParams, 'sort'),
      userCampaignIds: get(searchParams, 'userCampaignIds'),
      'filters[geoId]': get(searchParams, 'geoId') || null,
      'filters[region]': get(searchParams, ['filters', 'region']),
      'filters[city]': get(searchParams, ['filters', 'city']),
      'filters[cityArea]': get(searchParams, ['filters', 'city_area']),
      'filters[dateFrom]': get(searchParams, ['filters', 'date_from']),
      'filters[decreasePrice]': get(searchParams, ['filters', 'decrease_price']),
      'filters[photos]': get(searchParams, ['filters', 'photos']),
      'filters[make]': get(searchParams, ['filters', 'make']),
      'filters[model]': get(searchParams, ['filters', 'model']),
      'filters[priceMin]': guardNegativeOrZeroNumber(get(searchParams, ['filters', 'price_min'])),
      'filters[priceMax]': guardNegativeOrZeroNumber(get(searchParams, ['filters', 'price_max'])),
      'filters[yearMin]': guardNegativeOrZeroNumber(get(searchParams, ['filters', 'year_min'])),
      'filters[yearMax]': guardNegativeOrZeroNumber(get(searchParams, ['filters', 'year_max'])),
      'filters[mileageMin]': get(searchParams, ['filters', 'mileage_min']),
      'filters[mileageMax]': get(searchParams, ['filters', 'mileage_max']),
      'filters[doorsMin]': guardNegativeOrZeroNumber(get(searchParams, ['filters', 'doors_min'])),
      'filters[doorsMax]': guardNegativeOrZeroNumber(get(searchParams, ['filters', 'doors_max'])),
      'filters[carType]': get(searchParams, ['filters', 'car_type']),
      'filters[fuel]': get(searchParams, ['filters', 'fuel']),
      'filters[transmission]': get(searchParams, ['filters', 'transmission']),
      'redirect[cookieId]': trovit.installationId,
      'redirect[trackingCode]': get(trovit, ['trackingCodes', `${origin}`]),
      'redirect[pageViewId]': trovit.pageviewId,
      'redirect[suggester]': null,
      'redirect[userId]': userId,
    },
  };
}



// WEBPACK FOOTER //
// ./app/Serp/mappers/apiSearchRequest/cars/requestCarsMapper.js